import React from "react";
import { useLocation } from "react-router-dom";
import { ConsultationSection } from "../components/sections/ConsultationSection";
import { PageMeta } from "../components/shared/PageMeta";
export function Contact() {
  const location = useLocation();
  return <>
      <PageMeta title="Book a Consultation | Oceanside Living Perth Home Builders" description="Request a consultation with Oceanside Living about a home design, custom home, knock-down/rebuild, rear block or development in Perth." data-id="element-627" data-mp="1lqa0ti6u21z8" />
      <ConsultationSection key={location.search} headingLevel="h1" data-id="element-628" data-mp="t2xgzfs2489m" />
      <section aria-labelledby="office-heading" className="bg-paper py-14 md:py-20" data-id="element-629" data-mp="17r0hwar8strk">
        <div className="mx-auto grid max-w-site gap-8 px-5 md:grid-cols-3 md:px-10" data-id="element-630" data-mp="13022dde2vzpd">
          <h2 id="office-heading" className="text-[26px] font-semibold tracking-tight" data-id="element-631" data-mp="fa7rv2h8en8a">Contact details</h2>
          <address className="not-italic text-[16px] leading-relaxed text-slate" data-id="element-632" data-mp="abcy55hq7e9e">
            9/30 Dellamarta Road<br data-id="element-633" data-mp="15fot7hzrocba" />Wangara WA 6065
          </address>
          <p className="text-[16px] leading-relaxed text-slate" data-id="element-634" data-mp="15ex7qzzvvuyq">
            <a href="tel:+61862850876" className="text-charcoal underline underline-offset-4" data-id="element-635" data-mp="19g8qclkcbfxf">08 6285 0876</a>
            <br data-id="element-636" data-mp="1e8s5hmyoej4c" />
            <a href="mailto:admin@oceansideliving.com.au" className="break-all text-charcoal underline underline-offset-4" data-id="element-637" data-mp="1e8aasurnwcyj">admin@oceansideliving.com.au</a>
          </p>
        </div>
      </section>
    </>;
}